import { render } from "./ProductCartComponent.vue?vue&type=template&id=37223da2"
import script from "./ProductCartComponent.vue?vue&type=script&lang=js"
export * from "./ProductCartComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__